import { render } from "./TablaUnidades.vue?vue&type=template&id=693fb582&scoped=true"
import script from "./TablaUnidades.vue?vue&type=script&lang=js"
export * from "./TablaUnidades.vue?vue&type=script&lang=js"

import "./TablaUnidades.vue?vue&type=style&index=0&id=693fb582&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-693fb582"]])

export default __exports__